import store, { getStoreState } from 'config/store'
import { pathOr } from 'ramda'
import { log } from 'utils'

import { deleteMarkedTime, receiveMarkedTime } from './actions'

export const markTime = (name: string, time: number = Date.now()): void => {
  store.dispatch(receiveMarkedTime(name, time))
}

export const clearMarkedTime = (name: string): void => {
  const startTime = pathOr<number>(null, ['metrics', 'timeByName', name], getStoreState())
  if (startTime) {
    store.dispatch(deleteMarkedTime(name))
  }
}

export const measureTime = (name: string, time: number = Date.now()): number => {
  const startTime = pathOr<number>(null, ['metrics', 'timeByName', name], getStoreState())
  if (startTime) {
    store.dispatch(deleteMarkedTime(name))
    return time - startTime
  }

  log({ type: 'warn', data: [`Tried to measure "${name}" without mark`]})
  return null
}
